import React from 'react'
import SidebarProposal from '../../layouts/sidebarProposal/SidebarProposal'
import './styles.less'

export default function ProposalDashboard() {
  const mockMenu = []
  return (
    <>
      <SidebarProposal></SidebarProposal>
    </>
  )
}
